// Fictional identities for AI-controlled (SYSTEM) seats.
//
// A room can have more than one SYSTEM seat in play at the same time, and
// they used to all share the exact same generic "Sistema (IA)" name and 🤖
// avatar — making it impossible to tell which bot was which mid-game. Each
// seat now gets a distinct name/avatar instead, deterministically derived
// from the room id so it stays stable for the whole match (including across
// reconnects and screen remounts) without any backend changes.
const AI_PERSONAS = [
    { name: 'Manolo', avatar: '🤖' },
    { name: 'Miguel', avatar: '👾' },
    { name: 'Joaquin', avatar: '🦾' },
    { name: 'Esteban', avatar: '🧠' },
    { name: 'Sergio', avatar: '🎯' }
];

function hashSeed(seed) {
    const str = String(seed);
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = (hash * 31 + str.charCodeAt(i)) | 0;
    }
    return Math.abs(hash);
}

/** Deterministic per-seat AI persona `{ name, avatar }` for a given room. */
export function getAiPersona(roomId, seat) {
    return AI_PERSONAS[(hashSeed(roomId) + seat) % AI_PERSONAS.length];
}
